export const COMPANY = {
  name: "Novacore Services Pvt Ltd",
  legalName: "Novacore Services Pvt Ltd",
  tagline: "Human capital, engineered for growth.",
  short: "Novacore",
  email: "sales@novacoreservices.com",
  phone: "+91 98987 36584",
  address: "Shop No. 7, Srujan Complex, Near Sanjivini Hospital, Vastrapur, Ahmedabad 380054",
  founded: "2021",
  hires: "500+",
  clients: "40+",
  cities: "PAN India",
  socials: {
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
  },
};

export const SERVICES = [
  {
    slug: "permanent-staffing",
    title: "Permanent Staffing",
    tag: "01 — Talent Acquisition",
    excerpt:
      "End-to-end recruitment for mid-to-senior roles with a 12-day median close time and a 92% offer acceptance rate.",
    points: [
      "Executive & mid-management search",
      "Skill-mapped candidate pipelines",
      "Structured interview scorecards",
      "90-day replacement guarantee",
    ],
  },
  {
    slug: "contractual-staffing",
    title: "Contractual Staffing",
    tag: "02 — Flex Workforce",
    excerpt:
      "Deploy engineers, analysts, and specialists on our payroll while you scale project delivery without the fixed cost.",
    points: [
      "Rapid ramp-up in <10 days",
      "On-roll compliance & benefits",
      "Convert-to-hire flexibility",
      "PAN-India deployment",
    ],
  },
  {
    slug: "payroll-services",
    title: "Payroll Services",
    tag: "03 — Compensation Ops",
    excerpt:
      "Accurate, statutory-compliant payroll for teams of 20 to 20,000 — with a dedicated relationship manager for every account.",
    points: [
      "Monthly payroll processing",
      "PF, ESI, PT, TDS filings",
      "Employee self-service portal",
      "Form 16 & audit reports",
    ],
  },
  {
    slug: "rpo",
    title: "Recruitment Process Outsourcing",
    tag: "04 — Embedded Hiring",
    excerpt:
      "A fully embedded talent team that runs on your ATS, your brand, and your metrics — as an extension of your HR.",
    points: [
      "Dedicated pod of 4–20 recruiters",
      "Employer branding support",
      "Talent market intelligence",
      "SLA-driven delivery",
    ],
  },
  {
    slug: "hr-consulting",
    title: "HR Consulting",
    tag: "05 — Advisory",
    excerpt:
      "Design compensation frameworks, performance systems, and org structures that scale with your business.",
    points: [
      "Compensation benchmarking",
      "Performance & OKR design",
      "Policy & handbook drafting",
      "Culture & engagement audits",
    ],
  },
  {
    slug: "compliance",
    title: "Statutory Compliance",
    tag: "06 — Risk & Governance",
    excerpt:
      "Stay compliant across labour laws, factory acts, and shops & establishment across every state you operate in.",
    points: [
      "Labour law audits",
      "Registrations & returns",
      "State-wise compliance calendars",
      "Litigation support",
    ],
  },
];

export const INDUSTRIES = [
  { name: "Information Technology (IT)", roles: "Full-stack, DevOps, Data, Cloud, AI/ML" },
  { name: "Non-IT", roles: "Sales, Marketing, Operations, Finance, HR" },
  { name: "Banking & Financial Services (BFSI)", roles: "Ops, Risk, Compliance, Wealth" },
  { name: "Real Estate", roles: "Sales, Project Management, Leasing, Property Ops" },
  { name: "Healthcare & Pharma", roles: "Clinical, R&D, Medical Sales" },
  { name: "Manufacturing", roles: "Plant, Quality, Supply Chain, EHS" },
];

export const CASES = [
  {
    client: "A Series-C Fintech",
    result: "Scaled engineering from 40 to 210 in 9 months",
    metric: "5.2x",
    story:
      "Embedded an RPO pod of 8 recruiters that owned end-to-end hiring for backend, mobile, and data. Reduced cost-per-hire by 38%.",
    tags: ["RPO", "Engineering", "Fintech"],
  },
  {
    client: "A Global Manufacturing Group",
    result: "Payroll migrated for 6,800 employees across 4 plants",
    metric: "99.98%",
    story:
      "Consolidated three legacy payroll vendors into a single monthly cycle with statutory filings across four states.",
    tags: ["Payroll", "Compliance", "Manufacturing"],
  },
  {
    client: "A Regional Hospital Chain",
    result: "180 clinical hires closed in a single quarter",
    metric: "12 days",
    story:
      "Deployed a specialist healthcare recruitment desk with a candidate pipeline of 3,400+ verified nurses and doctors.",
    tags: ["Permanent Staffing", "Healthcare"],
  },
  {
    client: "A D2C Beauty Brand",
    result: "HR playbook + performance system rolled out in 45 days",
    metric: "45 days",
    story:
      "Built compensation bands, OKR framework, and manager enablement for a 220-person team preparing for Series B.",
    tags: ["HR Consulting", "D2C"],
  },
];

export const JOBS = [
  {
    id: "job-1",
    title: "Senior Talent Acquisition Partner",
    location: "Bengaluru, IN",
    type: "Full-time",
    team: "RPO Delivery",
    posted: "2 days ago",
  },
  {
    id: "job-2",
    title: "Payroll Operations Analyst",
    location: "Noida, IN",
    type: "Full-time",
    team: "Payroll & Compliance",
    posted: "5 days ago",
  },
  {
    id: "job-3",
    title: "Recruitment Consultant — BFSI",
    location: "Mumbai, IN",
    type: "Full-time",
    team: "Permanent Staffing",
    posted: "1 week ago",
  },
  {
    id: "job-4",
    title: "HR Consultant (Compensation & Benefits)",
    location: "Remote — India",
    type: "Full-time",
    team: "HR Advisory",
    posted: "1 week ago",
  },
  {
    id: "job-5",
    title: "Client Success Manager",
    location: "Gurugram, IN",
    type: "Full-time",
    team: "Client Partnerships",
    posted: "2 weeks ago",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Novacore didn't behave like a vendor — they built our talent function from the ground up when we were scaling.",
    author: "Recruitment Lead, Star Air",
  },
  {
    quote:
      "Payroll used to be a monthly fire drill. It's now a Friday non-event. That's the highest praise I can give.",
    author: "Founder, PRC Global",
  },
  {
    quote:
      "Their recruiters understand aviation hiring like they've flown the routes themselves — the quality of the shortlists is consistently strong.",
    author: "TA, IndiGo",
  },
];
